import { ActionTypes } from './actionTypes';
import type { LoadAddressFailed, LoadAddressRequest, LoadAddressSucceeded } from './actions';

import type { Coordinate } from '@cobliteam/common-types';

export const loadAddressRequest = (coordinate: Coordinate, disableCache?: boolean): LoadAddressRequest => ({
  type: ActionTypes.LOAD_ADDRESS_REQUEST,
  payload: { coordinate, disableCache },
});

export const loadAddressSucceeded = (address: string): LoadAddressSucceeded => ({
  type: ActionTypes.LOAD_ADDRESS_SUCCEEDED,
  payload: address,
});

export const loadAddressFailed = (): LoadAddressFailed => ({
  type: ActionTypes.LOAD_ADDRESS_FAILED,
});
